<template>
<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-3">
          <h6 class="modal-title">Add Screen(s)</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true"><close-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></close-icon></span>
          </button>
        </div>
        <div class="modal-body">
                 <multiselect
                        id="folderNameField"
                        v-model="userTypes" 
                        :options="userTypesOptions"
                        :multiple="true"
                        track-by="_id"
                        :custom-label="userTypeLabelCallback"
                        :close-on-select="false"
                        :show-no-results="false"
                        deselectLabel =""
                        selectLabel=""
                        selectedLabel=""
                        placeholder="Enter group name"
                        :hideSelected="false"
                        :showNoOptions="false"
                        @search-change="getusersOnKeyup($event)"
                        @select="userTypeOnSelect($event)"
                        @remove="userTypeOnRemove($event)"
                        style="margin-top: 7px;">
                        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                        <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.name"/>
                        <!-- <div class="user-name-or-image" :style="style(scope.option.name)">{{ scope.option.name.split("")[0] }}</div> -->
                        <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
                        </div>
                        <span slot="noResult">No results</span>
                        <span slot="noOptions" style="display:none"></span>
                    </multiselect>
              </div>
        <div class="modal-footer p-0 primary-btn-style">
          <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="close">Cancel</button>
          <button class="btn btn-outline-primary mr-2" @click.prevent="updateUserGroup()">Add</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiselect from 'vue-multiselect';
import {mapActions} from "vuex";
import Utils from "../../components.utils.js";
import closeIcon from "../core/InlineCancelField.vue";

export default {
props:["selectedUserGroupID","selectedIds","isEditGroup"],
  data: () => ({
    dialog: true,
    userTypes: [],
    userTypesOptions: [],
    selectedUserIdNameMap:{},
    screenIdList:[],
    postData: {},
    show:false
  }),
  components:{
    "multiselect":multiselect,
    "close-icon":closeIcon
  },
  methods:{
    close(){
        this.$emit('close')
    },
    style(name){
        let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
        }
        return style
    },
    userTypeLabelCallback(option){
      return `${option.name}`
    },
    userTypeOnSelect(option){
      let index = this.userTypesOptions.findIndex(item => item._id == option._id);
        if(index > -1){
            this.userTypesOptions[index].checked = true;
            this.screenIdList.push(option._id); 
            this.selectedUserIdNameMap[option._id] = option.name
        }
    },
    userTypeOnRemove(option){
      let index = this.userTypesOptions.findIndex(item => item._id == option._id);
      if(index > -1){
          this.screenIdList = this.screenIdList.filter(e => e != option._id)
          this.userTypesOptions[index].checked = false;
      }
    },
    getusersOnKeyup(option){
      if(typeof(option) != "undefined" && option.trim().length > 0){
        this.removeAlreadySelectedUsers(this.filteredUserGroups())
      }else if(option.length==0){
          this.removeAlreadySelectedUsers(this.usersList);
      }
    },
    filteredUserGroups(){
      if(this.search != null){
        if (!this.usersList.length) {
            return [];
          }
          return this.usersList.filter((item) => {
            const userGroupName = item.name.toLowerCase();
            const searchTerm = this.search.toLowerCase();
            return userGroupName.includes(searchTerm);
          });
        }else{
          return this.usersList;
      }
    },
     makeCheckBoxSelection(option){
        return this.userTypes.some((op) => op._id === option._id);
    },
    removeAlreadySelectedUsers(usersList){
        let usersInGroup = usersList;
        if(this.selectedIds != undefined && this.selectedIds.length){
            for(let j = 0; j < this.selectedIds.length; j++){
                let temp = this.selectedIds[j];
                    usersInGroup =  usersInGroup.filter(function(el){
                    return el._id != temp;
                });
            }
            this.userTypesOptions =  usersInGroup;
        }else{
            this.userTypesOptions = usersInGroup;
        }
    },
    updateUserGroup() {
      if(this.isEditGroup){
        let payload = {};
        if(this.userTypes.length > 0){
            for(let i=0; i<this.userTypes.length; i++){
                this.selectedIds.push(this.userTypes[i]._id)
                payload['user_list'] = this.selectedIds;
            }
        }
        payload.params = { _id: this.selectedUserGroupID };
        this.updateExistingUserGroup(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
            if (data.message.includes("Failed")) {
                this.$toast.warning(data.message);
            } else {
                this.$toast.success(data.message);
                this.close();
            }
            } else {
            this.$toast.error(data.message);
            }
        });
      this.close()
      }else{
          let temp = []
          if(this.userTypes.length > 0){
              for(let i=0; i<this.userTypes.length; i++){
                  temp.push(this.userTypes[i]._id)
              }
          }
          if(typeof(temp) == "undefined"){
              this.$emit('close',[],this.selectedUserIdNameMap)
              return
            }
            this.$emit('close', temp,this.selectedUserIdNameMap)
      }
    },
    updateUsersList(){
        this.getAllScreensFromServer().then((data) => {
            this.usersList = data["screens"];
        });
    },
    getSelectedScreenIdsList(){
      return this.screenIdList;
    },
    ...mapActions("screens", ["getAllScreensFromServer"])
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
          document.getElementById("folderNameField").focus();
          this.userTypesOptions = [];
        })
      }
    }
  },
  created(){
      this.updateUsersList();
      Object.assign(this.screenIdList, this.selectedIds);
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
    }, 200)
  },
}
</script>

<style lang="scss" scoped>
    $table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
.modal-dialog {
    max-width: 600px;
    width: 600px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: 227px;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $border-color;
    .modal-body{
      background: $primary-background;
      padding: 2rem;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:$input-field-and-label-font-size !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border: none !important;
    background: $secondary-background-color;
    height: 58px;
    .modal-title{
      color:$text-color;
    }
}          

.primary-btn-style{
    button{
        height: 35px;
        width: 70px;
        font-size:$input-field-and-label-font-size;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 30%;
  text-align: start;
  font-size: $input-field-and-label-font-size;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin-top: 3px;
}

.close-icon:hover{
  background: $bg-color-on-hover;
  border-radius: 20px;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
}

::v-deep{
    .multiselect{
        width:87% !important;
    }

    .multiselect__tags{
        border: none !important;
        border-bottom: 1px solid $active-blue !important;
        border-radius: 0px;
    }
    .multiselect__tag{
        border: $border-color;
        padding: 6px 23px 6px 10px;
        border-radius: 13px;
    }
    .multiselect__tag-icon{
        line-height: 25px;
    }
}
</style>